"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCustomer = exports.createAccount = void 0;

var _requester = require("./utils/requester");

var _storage = require("./utils/storage");

var _schemas = require("./schemas");

var _builders = require("./builders");

var _enums = require("./enums");

const createAccount = (0, _requester.requestHandler)(async (screenName, email, cpf, requester = _requester.authRequester) => {
  const payload = {
    screenName,
    email,
    cpf
  };
  const response = await requester().post(_enums.AUTH_ENDPOINT.createAccount, await (0, _builders.buildCreateAccountPayload)(payload));
  return _schemas.createAccountSchema.validate(response.data);
});
exports.createAccount = createAccount;
const createCustomer = (0, _requester.requestHandler)(async (email, requester = _requester.authenticatedRequester) => {
  const payload = await (0, _builders.buildCreateCustomerPayload)(email);
  const response = await requester().post(_enums.AUTH_ENDPOINT.createCustomer, payload);
  const parsedData = await _schemas.createCustomerSchema.validate(response.data);
  (0, _storage.setLegacyToken)(parsedData);
  return parsedData;
});
exports.createCustomer = createCustomer;